import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';

import { FdkIconName } from './icon.types';

export type FdkIconSize = number | string;

@Component({
  selector: 'fdk-icon',
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FdkIconComponent {
  @Input({ required: true }) name!: FdkIconName;
  @Input() size: FdkIconSize = 24;
  @Input('aria-label') ariaLabel: string | null = null;

  get normalizedAriaLabel(): string | null {
    const label = this.ariaLabel?.trim();
    return label ? label : null;
  }

  get ariaHidden(): 'true' | null {
    return this.normalizedAriaLabel ? null : 'true';
  }

  get role(): 'img' | null {
    return this.normalizedAriaLabel ? 'img' : null;
  }

  get resolvedSize(): string {
    return typeof this.size === 'number' ? `${this.size}px` : this.size;
  }
}
